import React, { Component } from "react";
import { Row, Col, Button, Collapse, Label, Input } from "reactstrap";
import EducationForm from "./Form";
import EducationHit from "./Hit";
import { getAllPersonalEducations } from "./Axios";

class EducationsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      personalEducations: [],
      collapse: false,
      personalEducation: null,
      isFirstStudy: true
    };

    this.handleUpdateHit = this.handleUpdateHit.bind(this);
  }

  componentDidMount() {
    this.getPersonalEducations();
  }

  getPersonalEducations = () => {
    getAllPersonalEducations(response => {
      this.setState({
        ...this.state,
        personalEducations: response.data,
        isFirstStudy: response.data.length === 0 ? true : false
      });
    });
  };

  toggle = () => {
    const { collapse } = this.state;

    this.setState({
      ...this.state,
      collapse: !collapse
    });
    if (collapse) {
      this.setState({
        personalEducation: null
      });
      this.refs.educationForm.handleCleanState();
    }
  };

  addPersonalEducation = (data) => {
    this.getPersonalEducations();
  };



  removePersonalEducation = id => {
    const currentPersonalEducations = [...this.state.personalEducations];
    const personalEducations = currentPersonalEducations.filter(
      personalEducation => personalEducation.id !== id
    );
    this.setState({ personalEducations });
  };

  handleEditPersonalEducation = personalEducation => {
    this.setState({ personalEducation, collapse: true });
  };

  handleUpdateHit = data => {
    this.refs[`educationHit-${data.id}`].updateHit(data);
  };

  handleChangeFirstStudy = e => {
    const personalEducations = [...this.state.personalEducations];
    this.setState({
      isFirstStudy: e.target.checked
    });
  }

  render() {
    const { personalEducations, collapse, personalEducation, isFirstStudy } = this.state;

    return (
      <Row>
        <Col md="12">
          { !isFirstStudy && (
            <Collapse isOpen={collapse} className="collapse-border">
              <EducationForm
                handleUpdateHit={this.handleUpdateHit}
                ref="educationForm"
                toggle={this.toggle}
                addPersonalEducation={this.addPersonalEducation}
                personalEducation={personalEducation}
                show_notification={this.props.show_notification}
              />
            </Collapse>
          )}
          <Row className="d-flex align-items-center">
            <Col md="6" className="">
              { personalEducations.length === 0 && (
                <div className="form-check">
                  <Label className="form-check-Label" htmlFor="firstStudy">
                    
                    <Input
                      className="form-check-Input mr-3"
                      id="firstStudy"
                      type="checkbox"
                      onChange={this.handleChangeFirstStudy}
                      checked={ isFirstStudy ? true : false }
                    />
                    Sin registro de estudios
                    
                  </Label>
                </div>
              )}
            </Col>

            <Col md="12" className="text-end">
              {!this.state.collapse && !isFirstStudy && (
                <Button outline color="primary" className="my-2" onClick={this.toggle}>
                  <i className="fas fa-plus me-2"></i>
                  Agregar Estudios
                </Button>
              )}
            </Col>
          </Row>
          
          {personalEducations.map(education => (
            <EducationHit
              ref={`educationHit-${education.id}`}
              key={education.id}
              personalEducation={education}
              handleEditPersonalEducation={this.handleEditPersonalEducation}
              removePersonalEducation={this.removePersonalEducation}
            />
          ))}
          <Row>
            
            <Col md="12 text-end">
              <Button
                color="primary"
                disabled={personalEducations.length > 0 ? false : !isFirstStudy}
                className="my-4"
                onClick={() => this.props.toggleTab("laboralinfo")}
              >
                Continuar
                <i className="fas fa-arrow-right ms-2"></i>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default EducationsIndex;
